import { render } from "./ConfRoles.vue?vue&type=template&id=5564b140"
import script from "./ConfRoles.vue?vue&type=script&lang=js"
export * from "./ConfRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__